import React, { useState, useEffect } from "react";
import { ThemeProvider } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormDatePicker from "../../../components/DatePicker";
import { useSelector, useDispatch } from "react-redux";

//import DataTable from './DataTable';
//import PlannedIdleTime from './PlannedIdleTime';
//import UnplannedIdleTime from './UnplannedIdleTime';
//import IHFTime from './IHFTime';
import { lightTheme } from "../../../SharedComponents/SharedComponentStyles";
import axios from "axios";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import Alert from "@material-ui/lab/Alert";
//Autocomplete
import Autocomplete from "@material-ui/lab/Autocomplete";
import MaterialTable from "material-table";
//import { tableOptionsUser } from "../../SharedComponents/SharedComponentStyles";
import { forwardRef } from "react";
//import Autocomplete from '@mui/material/Autocomplete';

//import TextArea from '@material-ui/core/TextareaAutosize';

import {
  AddBox,
  Check,
  DeleteOutline,
  Edit,
  SaveAlt,
  FilterList,
  FirstPage,
  LastPage,
  ChevronRight,
  ChevronLeft,
  Clear,
  Search,
  ArrowDownward,
  Remove,
  ViewColumn,
  CenterFocusStrong,
} from "@material-ui/icons";

const api = axios.create({
  baseURL: "InventoryMasterDetails",
});
const apiRpt = axios.create({
  baseURL: "InventoryReport",
});

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
var columns = [
  { title: "MRPController", field: "mrpcontroller" },
  { title: "Plant Id", field: "plantName" },
  {
    title: "System Inventory(INR)",
    field: "sysInvInr",
    type: "numeric",
    align: "right",
  },
  {
    title: "Physical Inventory(INR)",
    field: "phyInvInr",
    type: "numeric",
    align: "right",
  },
  {
    title: "NET Difference(INR)",
    field: "netdifference",
    type: "numeric",
    align: "right",
  },
  {
    title: "Positive Difference(INR)",
    field: "positiveDiffInr",
    type: "numeric",
    align: "right",
  },
  {
    title: "Negative Difference(INR)",
    field: "negativeDiffInr",
    type: "numeric",
    align: "right",
  },
  {
    title: "Gross Difference(INR)",
    field: "grossDiffInr",
    type: "numeric",
    align: "right",
  },
  {
    title: "Net Difference(%)",
    field: "netDiffPercentage",
    type: "numeric",
    align: "right",
  },
  {
    title: "Gross Difference(%)",
    field: "grossDiffPercentage",
    type: "numeric",
    align: "right",
  },
];
const data = [
  {
    mrp: "ABCDEF",
    id: "12345678",
    sys: "100",
    phy: "30",
    net: "40",
    pos: "60",
    neg: "50",
    gross: "90",
    net: "45",
    gdiff: "80",
  },
];

export default function MRPController(props) {
  const [fromdate, setFromdate] = useState(null);
  const [todate, setTodate] = useState(null);
  const [MRPReportData, setMRPReportData] = useState([]);
  const [plant, setPlant] = useState([]);
  const [openLoader, setopenLoader] = useState(false);
  const [placeValue, setPlaceValue] = useState("");
  const [placeName, setPlaceName] = useState("");
  //for MRP Controller
  const [MRPController, setMRPController] = useState([]);
  const [MRPControllerObj, setMRPControllerObj] = useState([]);
  const [MRPControllerName, setMRPControllerName] = useState([]);
  //for error handling
  const [iserror, setIserror] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [severity, setSeverity] = useState("success");
  //handle place
  const handlePlace = async (event) => {
    setPlaceValue(event.target.value);
    getMRPController();
  };
  const token = useSelector((state) => state.saveAzureTokenReducer.token);
  const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken
  );
  const uId = useSelector((state) => state.saveUIDReducer.uid);

  //MRP Controller
  const handleChangephyInvMRPController = async (event, newValue) => {
    setMRPControllerObj(newValue ? newValue : []);
    setMRPControllerName(newValue ? newValue.mrpcontroller : "");
  };
  const handleChangephyInvMRPControllerInput = (event, newInputValue) => {
    setMRPControllerName(newInputValue ? newInputValue : "");
  };

  const [NetDifferenceINRFrom, setNetDifferenceINRFrom] = useState("");
  const [NetDifferenceINRTo, setNetDifferenceINRTo] = useState("");
  //for Net differencePercent
  const [NetDifferencePercentFrom, setNetDifferencePercentFrom] = useState("");
  const [NetDifferencePercentTo, setNetDifferencePercentTo] = useState("");
  //for  handle difference INR
  const handleNetDifferenceINRFrom = async (event) => {
    setNetDifferenceINRFrom(event.target.value);
  };

  const handleNetDifferenceINRTo = async (event) => {
    setNetDifferenceINRTo(event.target.value);
  };

  //for  handle difference percent
  const handleNetDifferencePercentFrom = async (event) => {
    setNetDifferencePercentFrom(event.target.value);
  };

  const handleNetDifferencePercentTo = async (event) => {
    setNetDifferencePercentTo(event.target.value);
  };

  useEffect(async () => {
    getPlant(props.loginuser.response.gid);
    //getMRPController();
  }, []);

  

  async function getPlant(Id) {
   // console.log(userDetails);
    const headers = {
      Authorization: "Bearer " + bearerToken,
      UserEmail: userDetails.emailId,
      userId: uId,
      RoleName: userDetails.roleName,
      Gid: userDetails.gid,
      Roleid: userDetails.roleId,
      //AzureToken: token,
    };
    setopenLoader(true);
    await api
      .get("/getTblMstPlant/" + Id, {
        headers: headers,
      })
      .then((res) => {
        setPlant(res.data);
        setopenLoader(false);
      })
      .catch((error) => {
        console.log("Error in hitting api at page load. MRP Controller");
        setopenLoader(false);
      });
  }
  //setMRPControllerName

  async function getMRPController() {
    setopenLoader(true);
    let errorList = [];
    const headers = {
      Authorization: "Bearer " + bearerToken,
      UserEmail: userDetails.emailId,
      userId: uId,
      RoleName: userDetails.roleName,
      Gid: userDetails.gid,
      Roleid: userDetails.roleId,
     // AzureToken: token,
    };
    await api
      .get("/getMRPController/",{
        headers: headers, 
      })
      .then((res) => {
        if (res.data.length <= 0) {
          errorList.push("This plant has no active workflow");
          showMessage(errorList, true, "error");
          setPlaceValue("");
          setMRPControllerName("");
          setMRPReportData([]);
        }
        setMRPController(res.data);
       // console.log("MRPController", res.data);
        setopenLoader(false);
      })
      .catch((error) => {
        console.log("Error in hitting api at page load. MRP Controller");
        setopenLoader(false);
      });
  }
  const handleErrorClose = (e) => {
    setIserror(false);
  };
  function showMessage(errorList, flag, severity) {
    setErrorMessages(errorList);
    setIserror(flag);
    setSeverity(severity);
  }

  async function GetMRPReportDetails() {
    let isValidate = true;
    const headers = {
      Authorization: "Bearer " + bearerToken,
      UserEmail: userDetails.emailId,
      userId: uId,
      RoleName: userDetails.roleName,
      Gid: userDetails.gid,
      Roleid: userDetails.roleId,
      //AzureToken: token,
    };
    let errorList = [];
    if (placeValue == "" || placeValue === null || placeValue === undefined) {
      isValidate = false;
      errorList.push("Select Plant Name");
      showMessage(errorList, true, "error");
    }
    if (isValidate) {
      setopenLoader(true);
      let slipparam = {
        PlantId: Number(placeValue),
        Mrpcontroller: MRPControllerName,
        NetDiffernceINRFrom: NetDifferenceINRFrom,
        NetDiffernceINRTo: NetDifferenceINRTo,
        NetDifferncePercentFrom: NetDifferencePercentFrom,
        NetDifferncePercentTo: NetDifferencePercentTo,
      };
      await apiRpt
        .post("/GetMRPReportDetails/", slipparam,{headers: headers})
        .then((res) => {
          //if (res.data.length <= 0) {
          //    errorList.push("This plant has no active workflow");
          //    showMessage(errorList, true, 'error');
          //}
          if (
            res.data.combinationavalialble == 0 &&
            res.data.plantvaluesavailable == 1 &&
            res.data.getresultMRPReport.length <= 0
          ) {
            errorList.push("This plant has no data available");
            //changes in no data available
            showMessage(errorList, true, "error");
            setPlaceValue("");
            setMRPControllerName("");

            setMRPReportData([]);
          } else if (
            res.data.combinationavalialble == 0 &&
            res.data.plantvaluesavailable == 0 &&
            res.data.getresultMRPReport.length <= 0
          ) {
            errorList.push("This plant has no active workflow");
            showMessage(errorList, true, "error");
            setPlaceValue("");
            setMRPControllerName("");

            setMRPReportData([]);
          } else {
            //newly added
            setMRPReportData(res.data.getresultMRPReport);
           // console.log("MRPReportDetails", res.data);
          }

          setopenLoader(false);
        })
        .catch((error) => {
          console.log("Error in hitting api : SlipGenDetails");
          setopenLoader(false);
        });
    }
  }

  function clear() {
    setPlaceValue("");
    setMRPControllerObj("");
    setMRPControllerName("");
    setNetDifferenceINRFrom("");
    setNetDifferenceINRTo("");
    setNetDifferencePercentFrom("");
    setNetDifferencePercentTo("");
  }
  return (
    <ThemeProvider theme={lightTheme}>
      <div className="master-layout-data">
        <Box paddingTop={{ xs: "5rem", sm: "2rem" }} className="">
          <h3 className="clr-dark-blue d-flex jc-center mt-2 mb-1">
            MRP Controller wise Report
          </h3>
        </Box>
        <Grid
          container
          spacing={4}
          className="d-flex mt-1 fd-row mb-1 px-1 box-shadow width-100 bdr-radius "
        >
          <Grid item xs={12} sm={12} className="userManagement mt-1 mb-1">
            <div>
              {iserror && (
                <Alert severity={severity} onClose={handleErrorClose}>
                  {errorMessages.map((msg, i) => {
                    return <div key={i}>{msg}</div>;
                  })}
                </Alert>
              )}
            </div>
          </Grid>

          <Grid item xs={12} sm={3} className="d-flex Width-100  mt-1">
            <TextField
              className="lightInputFields  "
              select
              id=""
              //disabled={true}
              label="Plant Id"
              variant="filled"
              fullWidth
              name=""
              value={placeValue}
              onChange={handlePlace}
            >
              {plant.map((h, i) => (
                <MenuItem key={i} value={h.plantId}>
                  {h.plantName}
                </MenuItem>
              ))}
              {/*<MenuItem value="">*/}
              {/*    <em>Select</em>*/}
              {/*</MenuItem>*/}
              {/*<MenuItem value={10}>Ten</MenuItem>*/}
              {/*<MenuItem value={20}>Twenty</MenuItem>*/}
              {/*<MenuItem value={30}>Thirty</MenuItem>*/}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={3} className="d-flex mt-1 Width-100 mt-1 mt-1">
            <Autocomplete
              className="lightInputFields"
              //disablePortal
              id="combo-box-demo"
              value={MRPControllerObj}
              inputValue={MRPControllerName}
              options={MRPController}
              getOptionLabel={(option) =>
                option.mrpcontroller ? option.mrpcontroller : ""
              }
              onChange={handleChangephyInvMRPController}
              onInputChange={handleChangephyInvMRPControllerInput}
              // sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField {...params} label="MRP Controller" />
              )}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={3}
            className="d-flex jc-center width-100"
          ></Grid>
          <Grid
            item
            xs={12}
            sm={3}
            className="d-flex jc-center width-100"
          ></Grid>
          <Grid item xs={12} sm={3} className="d-flex mt-1 Width-100 mt-1 mt-1">
            {/*<Autocomplete className="lightInputFields"*/}
            {/*    //disablePortal*/}
            {/*    id="combo-box-demo"*/}
            {/*   // value={phyInvlocationObj}*/}
            {/*    //inputValue={phyInvlocationName}*/}
            {/*    //options={phyInvlocation}*/}
            {/*    //getOptionLabel={option => option.locationName ? option.locationName : ""}*/}
            {/*    //onChange={handleChangephyInvlocation}*/}
            {/*    //onInputChange={handleChangephyInvlocationInput}*/}
            {/*    // sx={{ width: 300 }}*/}
            {/*    renderInput={(params) => <TextField {...params} label="Difference of Inventory" />}*/}
            {/*/>*/}
            <FormControl>
              <InputLabel>Difference of Inventory(INR):</InputLabel>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={3} className="d-flex Width-100">
            <FormControl
              variant="filled"
              className="reg-form--division-icon mt-05"
              fullWidth
            >
              <TextField
                className="lightInputFields"
                label="From"
                variant="filled"
                fullWidth
                value={NetDifferenceINRFrom}
                onChange={handleNetDifferenceINRFrom}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={3} className="d-flex Width-100">
            <FormControl
              variant="filled"
              className="reg-form--division-icon mt-05"
              fullWidth
            >
              <TextField
                className="lightInputFields"
                label="To"
                variant="filled"
                fullWidth
                value={NetDifferenceINRTo}
                onChange={handleNetDifferenceINRTo}
              />
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            sm={3}
            className="d-flex jc-center width-100"
          ></Grid>
          <Grid item xs={12} sm={3} className="d-flex mt-1 Width-100 mt-1 mt-1">
            <FormControl>
              <InputLabel>Difference of Inventory(%):</InputLabel>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={3} className="d-flex Width-100 ">
            <FormControl
              variant="filled"
              className="reg-form--division-icon mt-05"
              fullWidth
            >
              <TextField
                className="lightInputFields"
                label="From"
                variant="filled"
                fullWidth
                value={NetDifferencePercentFrom}
                onChange={handleNetDifferencePercentFrom}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={3} className="d-flex Width-100">
            <FormControl
              variant="filled"
              className="reg-form--division-icon mt-05"
              fullWidth
            >
              <TextField
                className="lightInputFields"
                label="To"
                variant="filled"
                fullWidth
                value={NetDifferencePercentTo}
                onChange={handleNetDifferencePercentTo}
              />
            </FormControl>
          </Grid>

          <Grid
            item
            xs={12}
            sm={3}
            className="d-flex jc-center width-100"
          ></Grid>
          <Grid
            item
            xs={12}
            sm={3}
            className="d-flex jc-center width-100"
          ></Grid>
          <Grid
            item
            xs={12}
            sm={3}
            className="d-flex jc-center width-100"
          ></Grid>
          <Grid
            item
            xs={12}
            sm={3}
            className="d-flex jc-center width-100"
          ></Grid>
          <Grid
            item
            xs={12}
            sm={3}
            className="d-flex jc-center width-100"
          ></Grid>
          <Grid
            item
            xs={12}
            sm={4}
            className="d-flex jc-center width-100"
          ></Grid>
          {/*<Grid item xs={12} sm={3} className="d-flex jc-center width-100">*/}
          {/*    <Button className="ns-btn-primary mt-1 mr-1" onClick={calculateEfficiency}>*/}
          {/*        <span>Calculate Efficiency</span>*/}
          {/*    </Button>*/}
          {/*</Grid>*/}
          <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
            <Button
              className="ns-btn-primary mt-1 mr-1"
              onClick={GetMRPReportDetails}
            >
              <span>Refresh</span>
            </Button>
          </Grid>
          <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
            <Button className="ns-btn-primary mt-1 mr-1" onClick={clear}>
              <span>Reset</span>
            </Button>
          </Grid>
          {/* <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
                        <Button className="ns-btn-primary mt-1 mr-1" onClick={GetMRPReportDetails} >
                            <span>Export</span>
                        </Button>
                    </Grid>*/}

          <Grid item xs={12}>
            <MaterialTable
              title=""
              columns={columns}
              data={MRPReportData}
              //align={CenterFocusStrong}
              icons={tableIcons}
              //options={tableOptions}
              options={{
                exportButton: {
                  csv: true,
                  pdf: false,
                },
                exportAllData: true,
                exportFileName: "MRPControllerDetails",
                pageSizeOptions: [50, 75, 100], // rows selection options
                pageSize: 50,
                //maxBodyHeight: 600,
                search: false,
              }}
            />
          </Grid>
        </Grid>

        <Dialog
          open={openLoader}
          //onClose={handleClose}
          aria-labelledby="draggable-dialog-title"
          id="templateUploadSuccess"
          PaperProps={{
            style: {
              backgroundColor: "transparent",
              boxShadow: "none",
              borderColor: "transparent",
            },
          }}
        >
          <DialogContent>
            <CircularProgress />
          </DialogContent>
        </Dialog>
      </div>
    </ThemeProvider>
  );
}
